import { apiClient } from '@shared/api/client';
import {
  RoleListResponseSchema,
  RoleDetailResponseSchema,
  RoleMutationResponseSchema,
  type Role,
  type RoleDetail,
  type CreateRoleBody,
  type UpdateRoleBody,
} from './role-schemas';

export async function listRoles(orgId: string): Promise<Role[]> {
  const raw = await apiClient.get<unknown>(`/organization/${orgId}/roles`);
  const parsed = RoleListResponseSchema.parse(raw);
  return parsed.data;
}

export async function getRole(orgId: string, roleKey: string): Promise<RoleDetail> {
  const raw = await apiClient.get<unknown>(`/organization/${orgId}/roles/${roleKey}`);
  const parsed = RoleDetailResponseSchema.parse(raw);
  return parsed.data;
}

export async function createRole(orgId: string, body: CreateRoleBody): Promise<Role> {
  const raw = await apiClient.post<unknown>(`/organization/${orgId}/roles`, body);
  const parsed = RoleMutationResponseSchema.parse(raw);
  return parsed.data;
}

export async function updateRole(
  orgId: string,
  roleKey: string,
  body: UpdateRoleBody
): Promise<Role> {
  const raw = await apiClient.patch<unknown>(`/organization/${orgId}/roles/${roleKey}`, body);
  const parsed = RoleMutationResponseSchema.parse(raw);
  return parsed.data;
}

export async function deleteRole(
  orgId: string,
  roleKey: string,
  reassignTo?: string
): Promise<void> {
  await apiClient.delete(`/organization/${orgId}/roles/${roleKey}`, {
    params: reassignTo ? { reassignTo } : undefined,
  });
}
